/** @format */

import React, { useRef, useEffect } from "react";
import OktaSignIn from "@okta/okta-signin-widget";
import { useOktaAuth } from "@okta/okta-react";
import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import { config } from "../../env";

const SignInWidget = ({ onSuccess, onError }) => {
  const widgetRef = useRef();
  const { oktaAuth } = useOktaAuth();
  useEffect(() => {
    if (!widgetRef.current) {
      return () => {};
    }

    const widget = new OktaSignIn({
      ...config.widget,
    });

    widget.renderEl({ el: widgetRef.current }, onSuccess, onError);

    return () => widget.remove();
  }, [onSuccess, onError, oktaAuth]);

  // let href_uri =
  //   environment.orgUrl + "sso/saml2/" + environment.cargill_id + "?fromURI=" + environment.organisation_uri;
  return (
    <div>
      <div ref={widgetRef} />
      {/* <a
        href={href_uri}
        id='sso-link'
      >
      </a> */}
    </div>
  );
};

export default SignInWidget;
